import styled from "styled-components";

export const StyledRow = styled.div`
  display: flex;
  justify-content: ${(props) => props.align};
  margin-bottom: ${(props) => props.marginBottom};
  margin-right: ${props => props.marginRight};
  column-gap: ${(props) => props.columnGap};
  row-gap: ${(props) => props.rowGap};
  gap: ${(props) => props.gap};
  flex-direction: row;
  @media (max-width:360px) {
    flex-direction: column;
    width: 100%;
    div input{
      width: 100%;
    }
  }
`;

export const StyledCol = styled.div`
  /* display: grid;
  column-gap: 50px;
  grid-template-columns: ${(props) => {
    if (props.columns === 1) {
      return "1fr";
    } else if (props.columns === 2) {
      return "1fr 1fr";
    } else if (props.columns === 3) {
      return "1fr 1fr 1fr";
    } else if (props.columns === 4) {
      return "1fr 1fr 1fr 1fr";
    }
  }}; */
`;

export const StyledFormContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.align};
`;
